export default __webpack_public_path__ + "static/media/case.6857488c.jpg";